"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const purple = {
    50: '#EDE6F0',
    100: '#DACEE2',
    200: '#916BA7',
    300: '#6D3A89',
    400: '#48096C',
    500: '#410861',
    600: '#32064C',
    700: '#2B0840',
};
const red = {
    50: '#FDE9E6',
    100: '#FABCB5',
    200: '#F4736B',
    300: '#F1453A',
    400: '#ED0B09',
    500: '#BE1807',
    600: '#900C20',
    700: '#480610',
};
const colors = {
    primary: red,
    secondary: purple,
    accent: {
        blue: '#88FDFF',
        pink: '#FFC5EE',
        yellow: '#F9FF4E',
    },
    notification: {
        blue: '#276EF1',
    },
    purple,
    red,
    pink: {
        50: '#FFFBF8',
        100: '#FFF6F2',
        200: '#FFE9DE',
        300: '#FFE0D1',
        400: '#FFD2BD',
        500: '#FFB6AF',
        600: '#FF978C',
        700: '#CC7970',
    },
    lilac: {
        50: '#F6F7F9',
        100: '#F7F5FD',
        200: '#F3F1FF',
        300: '#EAE8FC',
        400: '#E5E2FB',
        500: '#CECBE2',
        600: '#B7B5C9',
        700: '#A09EB0',
    },
    blue: {
        50: '#EFF3FE',
        100: '#D4E2FC',
        200: '#A0BFF8',
        300: '#5B91F5',
        400: '#1A65F0',
        500: '#1E54B7',
        600: '#174291',
        700: '#102C60',
    },
    green: {
        50: '#E9F7F3',
        100: '#A8DFCF',
        200: '#7CCEB8',
        300: '#51BEA0',
        400: '#25AE88',
        500: '#1E8B6D',
        600: '#166852',
        700: '#0B3429',
    },
    yellow: {
        50: '#FFFAF0',
        100: '#FFF2D9',
        200: '#FFE3AC',
        300: '#FFCF70',
        400: '#FFC043',
        500: '#CC9A36',
        600: '#B3862F',
        700: '#806022',
    },
    orange: {
        50: '#FFF3EF',
        100: '#FFE1D6',
        200: '#FABDA5',
        300: '#FA9269',
        400: '#FF6937',
        500: '#CC492C',
        600: '#AE371C',
        700: '#7D2714',
    },
    gray: {
        50: '#F8F8F8',
        100: '#F0EDED',
        200: '#E0DEDE',
        300: '#C7C3C3',
        400: '#A0A0A0',
        500: '#787878',
        600: '#4B4B4B',
        700: '#302F2F',
        800: '#1E1E1E',
    },
};
exports.default = colors;
